module.exports = "https://r.nearpod.com/assets/media/image/AvenirLTStd-HeavyOblique-fd6656a1368dde5b1553d7298ecade3d.svg";